import { Pipe, PipeTransform, inject } from '@angular/core';

import { AuthService, Permission, RoleType } from '@bookly/shared';

@Pipe({
  name: 'roleRoute',
})
export class RoleRoutePipe implements PipeTransform {
  #authService = inject(AuthService);
  transform(roleType: RoleType): string {
    switch (roleType) {
      case RoleType.ADMIN:
        return (
          '/admin' +
          (this.#authService.hasPermissionsInRole(roleType, [
            Permission.CAN_MANAGE_USER_GROUP,
          ])
            ? '/group-management'
            : '')
        );
      case RoleType.ROOM_HOST:
        return '/room-host' + this.processRoleRoute(roleType);
      case RoleType.SERVICE_PROVIDER:
        return '/service-provider' + this.processRoleRoute(roleType);
    }
  }

  protected processRoleRoute(roleType: RoleType): string {
    if (
      this.#authService.hasPermissionsInRole(roleType, [
        Permission.CAN_MANAGE_ROOMBOOKINGS,
      ])
    ) {
      return '/booking-request';
    } else if (
      this.#authService.hasPermissionsInRole(roleType, [
        Permission.CAN_MANAGE_ROOMS,
      ])
    ) {
      return '/room-management';
    } else if (
      this.#authService.hasPermissionsInRole(roleType, [
        Permission.CAN_MANAGE_CALENDAR,
      ])
    ) {
      return '/calendar-view';
    } else if (
      this.#authService.hasPermissionsInRole(roleType, [
        Permission.CAN_MANAGE_USER_GROUP,
      ])
    ) {
      return '/group-management';
    } else {
      return '';
    }
  }
}
